import type Campaign from '../../../types/Campaign';

/**
 * Returns a target campaign and campaign objects to be used to render pill tag images from valid campaigns.
 * 4 pill tag images can be listed at a max (1 campaign tag + 3 presentational tags max)
 *
 * @param campaigns - valid campaigns
 * @return a target campaign and campaign objects for pill tag images
 */
const getTargetCampaignAndCampaignsForTags = (campaigns?: Campaign[], isLoggedIn?: boolean) => {
  const campaignsForTags: Campaign[] = [];

  const targetCampaign = campaigns
    ?.sort((a, b) => Number(b.requireAccount) - Number(a.requireAccount))
    .find(
      (campaign) =>
        !campaign.couponCode &&
        campaign.discount &&
        (isLoggedIn
          ? campaign.requireAccount || !campaign.requireAccount
          : !campaign.requireAccount)
    );

  const campaignForSupportTags = campaigns
    ?.filter((campaign) => !campaign.discount && campaign.image?.url)
    .slice(0, 3)
    .reduce(
      (acc, tag) => (acc.find((i) => i.image?.url === tag.image?.url) ? acc : acc.concat(tag)), // remove duplicate tags
      [] as Campaign[]
    );

  // add a campaign tag if any
  if (targetCampaign) campaignsForTags.push(targetCampaign);
  // add 3 presentational tags at a max if applicable
  if (campaignForSupportTags?.length) campaignsForTags.push(...campaignForSupportTags);

  return { targetCampaign, campaignsForTags };
};

export default getTargetCampaignAndCampaignsForTags;
